import React from 'react'
import classNames from 'classnames'

export const Checkbox = ({
  label = '',
  disabled = false,
  checked = false,
  onChange = () => {},
  labelClassNames,
  ...props
}) => {
  let checkboxClassNames = []
  let checkedClassNames = []
  let svgClassNames = []

  if (disabled) {
    checkboxClassNames.push('cursor-not-allowed')
  } else {
    checkboxClassNames.push('cursor-pointer')
    if (checked) {
      checkedClassNames.push('bg-primary')
    } else {
      checkedClassNames.push('bg-white')
    }
  }

  if (checked) {
    svgClassNames.push('block')
  } else {
    svgClassNames.push('hidden')
  }

  if (checked && disabled) {
    checkedClassNames.push('bg-grayscale-lighter')
  }

  return (
    <div>
      <label 
        className={classNames([
          'flex',
          'justify-start',
          'items-start'
          ])}
      >
        <div 
          className={classNames([
            'border',
            'border-grayscale',
            'rounded',
            'border-gray-400',
            'w-4',
            'h-4',
            'flex',
            'shrink-0',
            'justify-center',
            'items-center',
            'my-auto',
            'focus-within:ring-1',
            'focus-within:ring-offset-2',
            'focus-within:ring-secondary',
            ], {
              'mr-4': !!label.length,
            }, checkedClassNames)}
        >
          <input 
            type="checkbox" 
            checked={checked} 
            className={classNames([
              'opacity-0',
              'absolute'
            ],checkboxClassNames)}
            disabled={disabled}
            onChange={onChange}
            onClick={(e) => e.stopPropagation()}
          />
          <svg 
            className={classNames([
              'fill-current',
              'w-2',
              'h-2',
              'text-white',
              'pointer-events-none'
            ], svgClassNames)} 
            viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"
          /></svg>
        </div>

        { !!label.length &&
          <div 
            className={classNames([
              'select-none',
              'text-base',
            ], labelClassNames, disabled ? 'text-grayscale-lighter' : undefined)}
          >
            {label}
          </div>
        }
      </label>
    </div>
  )
}

export default Checkbox
